/** @format */

import { _$, Form } from '@king-design/react'
import yaml from 'js-yaml'
// 添加全局规则

// 数字类型
Form.addMethod(
  'isNumber',
  value => {
    return /^(-?\d+)(\.?\d+)?$/.test(value)
  },
  _$('请输入数字类型')
)
// 小数点后三位规则
Form.addMethod(
  'pointsLimit',
  value => {
    return /(^[0-9]{1,}$)|(^[0-9]{1,}\.{1}[0-9]{1,3}$)/.test(value)
  },
  _$('仅支持输入小数点后三位有效数字')
)
// 网址
Form.addMethod(
  'isWebAddress',
  value => {
    return (
      /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'*+,;=.]+$/.test(value) ||
      /^(.)+@(.)+$/.test(value) ||
      /^(.)+:(.)+$/.test(value)
    )
  },
  _$('请输入正确地址')
)

// 所有姓名
Form.addMethod(
  'userName',
  value => {
    return /^[-a-zA-Z0-9\u4E00-\u9FA5,_@#.]{2,64}$/.test(value)
  },
  _$('2-64个字符组成，支持中文，字母，数字，以及,-_@#.')
)

// 手机号
Form.addMethod(
  'phone',
  value => {
    return /^1[3|4|5|6|7|8|9]\d{9}$/.test(value)
  },
  _$('请输入正确的手机号码')
)

// 验证码
Form.addMethod(
  'verifyCode',
  value => {
    return /^\d{6}$/.test(value)
  },
  _$('请输入6位数字验证码')
)

// 字符串拆分后验证网址类型
Form.addMethod(
  'verifyAdress',
  value => {
    const mail_arr = value.split(',')
    let result = true
    const reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
    for (let i = 0; i < mail_arr.length; i++) {
      mail_arr[i] = mail_arr[i].replace(/\s*/g, '')
      if (!reg.test(mail_arr[i])) {
        result = false
        return
      }
    }
    return result
  },
  _$('请输入正确的邮箱地址，多个邮箱用逗号( , )分割,最后一个邮箱不用加逗号')
)

// 金额（数字，小数点后最多保留两位）
Form.addMethod(
  'amount',
  value => {
    return /(^[0-9]{1,}$)|(^[0-9]{1,}\.{1}[0-9]{1,2}$)/.test(value)
  },
  _$('最多保留两位小数')
)

// 所有姓名
Form.addMethod(
  'yaml',
  value => {
    try {
      yaml.load(value)
      return true
    } catch (e) {
      return false
    }
  },
  _$('请输入正确的yaml格式')
)

// 告警规则:label-value && annotation-value
Form.addMethod(
  'ruleDescription',
  value => {
    return /^[\u4E00-\u9FFF\u3000-\u303F\uFF00-\uFFEF\u0020-\u007E\n\r\t]{2,4096}$/.test(value)
  },
  '2-4096个字符组成，支持中文，字母，数字，以及常见符号'
)

// 告警规则:label-key && annotation-key
Form.addMethod(
  'ruleLabelKey',
  value => {
    return /^[a-z][a-z0-9_]{0,63}$/.test(value)
  },
  '1-64个字符组成，小写字母开头，支持小写字母，数字以及_'
)

// 名称验证
export const nameValidate = value => {
  return /^[a-z,\u4E00-\u9FA5,0-9,A-Z,-_@#.]{2,64}$/.test(value)
}
